import { WebSocketEvents } from '@/enums/apiEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { handleMessageIncoming } from '@/providers/WebSocketProvider/utils/handleMessageIncoming.tsx';
import { handleUserActivated } from '@/providers/WebSocketProvider/utils/handleUserActivated.ts';
import { handleUserVerificationFailed } from '@/providers/WebSocketProvider/utils/handleUserVerificationFailed.ts';
import { handleOneTimePurchase } from '@/providers/WebSocketProvider/utils/handleOneTimePurchase.ts';
import { handleLikeCreated } from '@/providers/WebSocketProvider/utils/handleLikeCreated.tsx';
import { handleDialogRequestAccepted } from '@/providers/WebSocketProvider/utils/handleDialogRequestAccepted.tsx';
import { handleDialogRequestDeclined } from '@/providers/WebSocketProvider/utils/handleDialogRequestDeclined.tsx';
import { handlePhotoApproved } from '@/providers/WebSocketProvider/utils/handlePhotoApproved.ts';
import { handlePhotoRejected } from '@/providers/WebSocketProvider/utils/handlePhotoRejected.ts';
import { handleDialogDeleted } from '@/providers/WebSocketProvider/utils/handleDialogDeleted.ts';
import { handleUserBanned } from '@/providers/WebSocketProvider/utils/handleUserBanned.ts';
import { handleSubscriptionPurchase } from '@/providers/WebSocketProvider/utils/handleSubscriptionPurchase.ts';
import { handleDialogDeactivated } from '@/providers/WebSocketProvider/utils/handleDialogDeactivated.ts';
import { handleContactDeleted } from '@/providers/WebSocketProvider/utils/handleContactDeleted.ts';
import { handleTonChallengeUnlocked } from '@/providers/WebSocketProvider/utils/handleTonChallengeUnlocked.ts';
import { handleTonChallengeAdvanced } from '@/providers/WebSocketProvider/utils/handleTonChallengeAdvanced.ts';
import { handleTonTransactionCreated } from '@/providers/WebSocketProvider/utils/handleTonTransactionCreated.ts';
import { handleTonChallengeCompleted } from '@/providers/WebSocketProvider/utils/handleTonChallengeCompleted.ts';
import { handleBlocked } from '@/providers/WebSocketProvider/utils/handleBlocked.ts';
import { handleVideoApproved } from '@/providers/WebSocketProvider/utils/handleVideoApproved.ts';
import { handleVideoRejected } from '@/providers/WebSocketProvider/utils/handleVideoRejected.ts';

export const handleEvents: Record<
  WebSocketEvents,
  (ctxData: WebSocketMessage) => void
> = {
  [WebSocketEvents.TYPE_MESSAGE_INCOMING]: handleMessageIncoming,
  [WebSocketEvents.TYPE_DIALOG_CREATED]: () => undefined,
  [WebSocketEvents.TYPE_DIALOG_DELETED]: handleDialogDeleted,
  [WebSocketEvents.TYPE_DIALOG_DEACTIVATED]: handleDialogDeactivated,
  [WebSocketEvents.TYPE_USER_ACTIVATED]: handleUserActivated,
  [WebSocketEvents.TYPE_USER_VERIFICATION_FAILED]: handleUserVerificationFailed,
  [WebSocketEvents.TYPE_ONE_TIME_PURCHASE]: handleOneTimePurchase,
  [WebSocketEvents.TYPE_LIKE_CREATED]: handleLikeCreated,
  [WebSocketEvents.TYPE_DIALOG_REQUEST_ACCEPTED]: handleDialogRequestAccepted,
  [WebSocketEvents.TYPE_DIALOG_REQUEST_DECLINED]: handleDialogRequestDeclined,
  [WebSocketEvents.TYPE_PHOTO_APPROVED]: handlePhotoApproved,
  [WebSocketEvents.TYPE_PHOTO_REJECTED]: handlePhotoRejected,
  [WebSocketEvents.TYPE_USER_BANNED]: handleUserBanned,
  [WebSocketEvents.TYPE_SUBSCRIPTION_PURCHASE]: handleSubscriptionPurchase,
  [WebSocketEvents.TYPE_CONTACT_DELETED]: handleContactDeleted,
  [WebSocketEvents.TYPE_TON_CHALLENGE_UNLOCKED]: handleTonChallengeUnlocked,
  [WebSocketEvents.TYPE_TON_CHALLENGE_COMPLETED]: handleTonChallengeCompleted,
  [WebSocketEvents.TYPE_TON_CHALLENGE_ADVANCED]: handleTonChallengeAdvanced,
  [WebSocketEvents.TYPE_TON_TRANSACTION_CREATED]: handleTonTransactionCreated,
  [WebSocketEvents.TYPE_BLOCK_CREATED]: handleBlocked,
  [WebSocketEvents.TYPE_VIDEO_APPROVED]: handleVideoApproved,
  [WebSocketEvents.TYPE_VIDEO_REJECTED]: handleVideoRejected
};
